import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            live_name: '',
            shop_name:'',
            start_at:'',
            end_at:'',

        }
    }
}

const mutations = {
    reviseGiftRewardParams(state, val) {
        state.params = val
    }
}

export default {
    state,
    mutations
}